import Alpine from 'alpinejs';

Alpine.data('acceptContract', (adminURL, postId, userEmail) => ({
  adminURL,
  loading: false,
  success: false,

  fillForm() {
    const form = document.querySelector('.wpcf7');

    const userNameInput = form.querySelector('input[name="user_email"]');
    userNameInput.value = userEmail;
  },

  submit() {
    this.loading = true;

    this.fillForm();

    const formData = new FormData();
    formData.append('action', 'acceptContract');

    formData.append('post_id', postId);
    formData.append('user_email', userEmail);

    fetch(this.adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then(() => {
        const submitFormBtn = document.querySelector('.wpcf7-submit');
        submitFormBtn.click();

        this.success = true;

        this.loading = false;
      });
  },
}));
